export const AVAILABLE_SLOTS_TYPES: Record<string, common.AvailableSlotsType> = {
  HalfDay: 'AM/PM',
  TwoHour: 'TwoHour',
  TwoHourAlt: 'TwoHourAlt',
  TwoHourMix: 'TwoHourMix',
};
